import { defineMessages } from 'react-intl';

export default defineMessages({
  acmTitleVariantOne: {
    id: 'cc4.aside-acm-variant-one-title',
    defaultMessage: 'What you can expect',
  },
  acmTitleVariantTwo: {
    id: 'cc4.aside-acm-variant-two-title',
    defaultMessage: 'What you can expect',
  },
  acmTitleVariantThree: {
    id: 'cc4.aside-acm-variant-three-title',
    defaultMessage: 'What you can expect',
  },
  acmTitleVariantPermission: {
    id: 'cc4.aside-acm-variant-permission-title',
    defaultMessage: 'What you can expect',
  },
  acmTitleOneVariantPermission: {
    id: 'cc4.aside-acm-variant-permission-box-title-one',
    defaultMessage: 'What you can expect',
  },
  acmTitleTwoVariantPermission: {
    id: 'cc4.aside-acm-variant-permission-box-title-two',
    defaultMessage: 'Submit your claim',
  },
  acmTitleThreeVariantPermission: {
    id: 'cc4.aside-acm-variant-permission-box-title-three',
    defaultMessage: 'We handle the entire process',
  },
  acmSubTitleOneVariantPermission: {
    id: 'cc4.aside-acm-variant-permission-box-content-one',
    defaultMessage:
      'Even if the airline rejects your claim, we’ll take them to court to fight for what youre owed.',
  },
  acmSubTitleTwoVariantPermission: {
    id: 'cc4.aside-acm-variant-permission-box-content-two',
    defaultMessage:
      'You get up to €600 per passenger, minus our "no win, no fee" commission (35% for most claims, +15% if the case proceeds to court)',
  },
  acmSubTitleThreeVariantPermission: {
    id: 'cc4.aside-acm-variant-permission-box-content-three',
    defaultMessage:
      'Even if the airline rejects your claim, we’ll take them to court to fight for what youre owed.',
  },
  acmTitleOneVariantOne: {
    id: 'cc4.aside-acm-variant-one-box-title-one',
    defaultMessage: 'Submit your claim',
  },
  acmTitleOneVariantTwo: {
    id: 'cc4.aside-acm-variant-two-box-title-one',
    defaultMessage: 'Submit your claim',
  },
  acmTitleOneVariantThree: {
    id: 'cc4.aside-acm-variant-three-box-title-one',
    defaultMessage: 'Submit your claim',
  },

  acmTitleTwoVariantOne: {
    id: 'cc4.aside-acm-variant-one-box-title-two',
    defaultMessage: 'We handle the entire process',
  },
  acmTitleTwoVariantTwo: {
    id: 'cc4.aside-acm-variant-two-box-title-two',
    defaultMessage: 'We handle the entire process',
  },
  acmTitleTwoVariantThree: {
    id: 'cc4.aside-acm-variant-three-box-title-two',
    defaultMessage: 'We handle the entire process',
  },

  acmTitleThreeVariantOne: {
    id: 'cc4.aside-acm-variant-one-box-title-three',
    defaultMessage: 'You get compensated',
  },
  acmTitleThreeVariantTwo: {
    id: 'cc4.aside-acm-variant-two-box-title-three',
    defaultMessage: 'You get compensated',
  },
  acmTitleThreeVariantThree: {
    id: 'cc4.aside-acm-variant-three-box-title-three',
    defaultMessage: 'You get compensated',
  },

  acmSubTitleOneVariantOne: {
    id: 'cc4.aside-acm-variant-one-box-content-one',
    defaultMessage:
      'Even if the airline rejects your claim, we’ll take them to court to fight for what youre owed.',
  },
  acmSubTitleOneVariantTwo: {
    id: 'cc4.aside-acm-variant-two-box-content-one',
    defaultMessage:
      'Even if the airline rejects your claim, we’ll take them to court to fight for what youre owed.',
  },
  acmSubTitleOneVariantThree: {
    id: 'cc4.aside-acm-variant-three-box-content-one',
    defaultMessage:
      'Even if the airline rejects your claim, we’ll take them to court to fight for what youre owed.',
  },

  acmSubTitleTwoVariantOne: {
    id: 'cc4.aside-acm-variant-one-box-content-two',
    defaultMessage:
      'You get up to €600 per passenger, minus our "no win, no fee" commission (35% for most claims, +15% if the case proceeds to court)',
  },
  acmSubTitleTwoVariantTwo: {
    id: 'cc4.aside-acm-variant-two-box-content-two',
    defaultMessage:
      'You get up to €600 per passenger, minus our "no win, no fee" commission (35% for most claims, +15% if the case proceeds to court)',
  },
  acmSubTitleTwoVariantThree: {
    id: 'cc4.aside-acm-variant-three-box-content-two',
    defaultMessage:
      'You get up to €600 per passenger, minus our "no win, no fee" commission (35% for most claims, +15% if the case proceeds to court)',
  },

  acmSubTitleThreeVariantOne: {
    id: 'cc4.aside-acm-variant-one-box-content-three',
    defaultMessage:
      'You get up to €600 per passenger, minus our "no win, no fee" commission (35% for most claims, +15% if the case proceeds to court)',
  },
  acmSubTitleThreeVariantTwo: {
    id: 'cc4.aside-acm-variant-two-box-content-three',
    defaultMessage:
      'You get up to €600 per passenger, minus our "no win, no fee" commission (35% for most claims, +15% if the case proceeds to court)',
  },
  acmSubTitleThreeVariantThree: {
    id: 'cc4.aside-acm-variant-three-box-content-three',
    defaultMessage:
      'You get up to €600 per passenger, minus our "no win, no fee" commission (35% for most claims, +15% if the case proceeds to court)',
  },

  legalPaymentConfirmationDescription: {
    id: 'cc4.shareable-legal-payment-confirmation-details.description',
    defaultMessage:
      'Thank you for confirming that you have received a payment from the airline. Before we are able to finalise your claim, please confirm the following details:',
  },
  paymentNoMatchConfirmationDescription: {
    id: 'cc4.shareable-payment-no-match-confirmation-details.description',
    defaultMessage:
      'Thank your for confirming that you have been paid out by the airline in the meantime. A member of our team will contact you as soon as possible so that we can finalize your claim.',
  },
  paymentNoMatchConfirmationSubDescription: {
    id: 'cc4.shareable-payment-no-match-confirmation-details.sub.description',
    defaultMessage: 'For now we would like to wish you a pleasant day.',
  },
  paymentConfirmationDateLabel: {
    id: 'cc4.form.shareable-payment-confirmation-details.label.date',
    defaultMessage: 'On which date did you receive the payment',
  },
  paymentConfirmationAmountLabel: {
    id: 'cc4.form.shareable-payment-confirmation-details.label.amount',
    defaultMessage: 'What is the amount you received',
  },
  paymentConfirmationTextArea: {
    id: 'cc4.form.shareable-payment-confirmation-details.label.textarea',
    defaultMessage: 'Tell us more (optional)',
  },
  paymentConfirmationMessageDescription: {
    id: 'cc4.shareable-payment-confirmation-message.description',
    defaultMessage:
      'Thank you for confirming that you have been paid out by the airline in the meantime. A member of our team will contact you as soon as possible so that we can finalize your claim.',
  },
  paymentConfirmationMessageSubDescription: {
    id: 'cc4.shareable-payment-confirmation-message.sub.description',
    defaultMessage: 'For now we would like to wish you a pleasant day.',
  },
  noPaymentConfirmationMessageTitle: {
    id: 'cc4.shareable-no-payment-confirmation-message.title',
    defaultMessage: 'No payment received yet',
  },
  noPaymentConfirmationMessageDescription: {
    id: 'cc4.shareable-no-payment-confirmation-message.description',
    defaultMessage:
      'Thank you for confirming that you have yet to receive the payment from the airline. Our team will now chase this up with the airline so that we can get your money as soon as possible. Rest assured that a member of our team will contact you directly as soon as we know more.',
  },
  noPaymentConfirmationMessageSubDescription: {
    id: 'cc4.shareable-no-payment-confirmation-message.sub.description',
    defaultMessage:
      'For now we would appreciate it if you could let us know if the payment has been received in the meantime.',
  },
});
